var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTurnRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.398 8.349a.5.5 0 000-.721l-3.16-3.036c-.399-.383-1.032.069-.8.57l1.21 2.616a.5.5 0 010 .42l-1.21 2.616c-.232.502.401.954.8.57l3.16-3.035z",
    fill: "#222B40"
  })));
}
export default SvgTurnRight;